module.exports = ol.source.TileJSON;